module.exports = __webpack_public_path__ + "img/B低通1000.7780c14a.png";